module.exports = __webpack_public_path__ + "media/src/components/PersonalAccidentInsurancePage/WhyNeedSection/4-0f4001edab0efe68696390e18741629a.png";